export default __webpack_public_path__ + "static/5-e8ec651dcc66d4e05f75f37aaa6ef956.jpeg";